import React, { FC } from "react";
import { IconButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { ColorWrapper, ColorButton, ColorItem, AnchorContainer } from "./styled";
import { Tooltip } from "../SymbolEditor/components/Classifiers/styled";

import { ColorScaleFieldProps, ColorsContainerProps } from "./types";

const ColorsContainer: FC<ColorsContainerProps & PropsOf<typeof ColorButton>> = ({ colors, ...props }) => {
  return (
    <ColorButton ref={props.innerRef} {...props}>
      {colors && colors.map((color, index) => <ColorItem color={color.toString()} key={color.toString() + index} />)}
    </ColorButton>
  );
};

export const ColorScaleField: FC<ColorScaleFieldProps> = ({
  iconKind,
  buttonAction,
  isActive,
  colors,
  width,
  disabled,
  error,
  onColorClick,
  tooltipProps,
  ...props
}) => {
  const { t } = useTranslation("common");

  return (
    <AnchorContainer kind={iconKind} isOpen={false} width={width} disabled={disabled} error={error} {...props}>
      <ColorWrapper onClick={onColorClick}>
        <Tooltip content={t("colorScaleField.editClassifier")}>
          {ref => <ColorsContainer innerRef={ref} colors={colors} disabled={disabled} />}
        </Tooltip>
      </ColorWrapper>

      {tooltipProps ? (
        <Tooltip {...tooltipProps}>
          {ref => (
            <IconButton innerRef={ref} kind={iconKind} onClick={buttonAction} primary={isActive} disabled={disabled} />
          )}
        </Tooltip>
      ) : (
        <IconButton kind={iconKind} onClick={buttonAction} primary={isActive} disabled={disabled} />
      )}
    </AnchorContainer>
  );
};
